
angular.module("clientDashboardApp").factory("scoreResultsService", ($http) => {

  return {
    timelineSegments({
      start, end,
      groupId,
      scoringSetId,
      scorePaths
    }) {
      return $http.get("/v5/scores/timelineSegments", {
        params: {
          start, end,
          groupId,
          scoringSetId,
          scorePaths
        }
      }).then(x => x.data)
    },

    overallAverages({
      start, end,
      groupId,
      scorePaths
    }) {
      return $http.get("/v5/scores/overallAverages", {
        params: {
          start, end,
          groupId, scorePaths
        }
      }).then(x => x.data)
    },

    overallChange({
                    start, end,
                    groupId,
                    scorePaths
                  }) {
      return $http.get("/v5/scores/overallChange", {
        params: {
          start, end,
          groupId, scorePaths
        }
      }).then(x => x.data)
    },

    latestScores({
      scoreConfigId,
      scoreConfigVersion,
      accountIds,
      verticalIds,
      scorePaths
    }) {
      return $http.get("/v5/scores/latestScores", {
        params: {
          scoreConfigId, scoreConfigVersion, accountIds, verticalIds, scorePaths
        }
      }).then(x => x.data)
    },

    locationAverages({
      start, end, locationIds, scorePaths
    }) {

      return $http.get("/v5/scores/locations/averages", {
        params: {
          start, end, locationIds, scorePaths
        }
      }).then(x => x.data)

    },

    locationAveragesForGroupId ({
      start, end, groupId, scorePaths, locationIds
    }) {

      return $http.get(`/v5/scores/locations/averages/${groupId}`, {
        params: {
          start, end, scorePaths, locationIds
        }
      }).then(x => x.data)

    },

    getSortedLocationIds({
      start, end, groupId, locationIds, sortField
    }) {
      return $http.get("/v5/scores/locations/averagesSort", {
        params: {
          start, end, groupId, sortField, locationIds
        }
      }).then(x => x.data)
    },

    locationGroupAverages({
      start, end, scorePaths, groupId, sortField}) {
      return $http.get("/v5/scores/groups/averages", {
        params: {
          start, end, scorePaths, groupId, sortField
        }
      }).then(x => x.data)
    },

    getSortedGroupIds({
                           start, end, groupId, sortField
                         }) {
      return $http.get("/v5/scores/groups/averagesSort", {
        params: {
          start, end, groupId, sortField
        }
      }).then(x => x.data)
    }

  }

})
